import type { ThemeConfig } from 'antd';

/** Brand tokens lifted from the eTravel design spec. */
export const BRAND = {
  primary: '#302b78',
  primaryHover: '#251f60',
  page: '#f5f6fb',
  success: '#2e7d32',
  successSoft: '#e9f4ea',
  danger: '#c62828',
  dangerSoft: '#fbeaea',
} as const;

export const themeConfig: ThemeConfig = {
  token: {
    colorPrimary: BRAND.primary,
    colorLink: BRAND.primary,
    colorBgLayout: BRAND.page,
    borderRadius: 8,
    fontFamily:
      '"Somar Sans", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  components: {
    Layout: { headerBg: '#ffffff', siderBg: '#ffffff', headerPadding: '0 24px' },
  },
};
